<template>
  <div>Sender</div>
</template>

<script>
export default {
  name: "EmailSender",
};
</script>